import { http } from 'vue'

export default {
  // load products from the API server
  loadProducts (context, params = {}) {
    let query = ''
    if (params.counter) query += '&with=counter'
    query += '&subcategory_id=' + ((params.subcategoryId) ? params.subcategoryId : 0)
    query += (params.companyId) ? '&company_id=' + params.companyId : ''
    return http.get('products?sort=name' + query)
  },
  // load product from the API server
  loadProduct (context, params = {}) {
    const withParam = params.with ? '?with=' + params.with : ''
    const companyIdParam = params.companyId ? '&company_id=' + params.companyId : ''
    return http.get('products/' + params.id + withParam + companyIdParam)
  },
  // create address at the API server
  postProduct (context, params = {}) {
    return http.post('products', params.data)
  },
  // edit address at the API server
  putProduct (context, params = {}) {
    return http.put('products/' + params.id, params.data)
  },
  // delete address at the API server
  deleteProduct (context, params = {}) {
    return http.delete('products/' + params.id)
  },
  // save products at the store
  saveProducts (context, payload) {
    context.commit('SAVE_PRODUCTS', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/products/actions.js